import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

const MobileView = React.memo(() => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 2,
        paddingBottom: 8,
      }}
    >
      <Box
        sx={{
          width: "85%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: {
              xs: "2.5rem",
              sm: "3rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          Our services
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column-reverse",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_1.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: {
                    xs: "1rem",
                    sm: "1.3rem",
                    md: "1.5rem",
                    laptop: "1.8rem",
                  },
                  lineHeight: "40px",
                }}
                variant="h3"
              >
                SaaS Services
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  textAlign: "center",
                  paddingRight: {
                    lg: 15,
                    xl: 30,
                  },
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We design, develop, and scale SaaS solutions that are secure,
                high-performing, and cloud-native. Whether you're launching a
                new platform or optimizing an existing one, we ensure seamless
                scalability, multi-tenancy, and integration to help businesses
                grow efficiently.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: {
                    xs: "1rem",
                    sm: "1.3rem",
                    md: "1.5rem",
                    laptop: "1.8rem",
                  },
                  lineHeight: "40px",
                }}
                variant="h3"
              >
                Data Analytics & Business Intelligence
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  paddingLeft: {
                    lg: 15,
                    xl: 30,
                  },
                  textAlign: "center",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We provide actionable insights through data processing,
                visualization, and strategic analysis, helping businesses
                identify trends, optimize operations, and drive smarter
                decision-making. Our expertise ensures that organizations can
                leverage their data effectively, improving efficiency and
                gaining a competitive edge.
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_2.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column-reverse",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_3.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  lineHeight: "40px",
                  fontSize: {
                    xs: "1rem",
                    sm: "1.3rem",
                    md: "1.5rem",
                    laptop: "1.8rem",
                  },
                }}
                variant="h3"
              >
                Web & Mobile App Development
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  textAlign: "center",
                  paddingRight: {
                    lg: 15,
                    xl: 30,
                  },
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We build scalable and user-centric web and mobile applications
                that enhance engagement, streamline operations, and drive
                business growth. Our solutions are designed for performance,
                flexibility, and seamless user experiences, ensuring your
                business stays ahead in the digital landscape.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

const WebView = React.memo(() => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <Box
        sx={{
          width: "85%",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: {
              xs: "2.5rem",
              sm: "3rem",
              md: "3rem",
              laptop: "3.5rem",
              lg: "4rem",
              xl: "4.25rem",
            },
          }}
          variant="h2"
        >
          Our services
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 9,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_1.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: {
                    xs: "1.6rem",
                    laptop: "1.8rem",
                    md: "1.5rem",
                    xl: "2.5rem",
                  },
                }}
                variant="h3"
              >
                SaaS Services
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  paddingRight: {
                    lg: 15,
                    xl: 35,
                  },
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We design, develop, and scale SaaS solutions that are secure,
                high-performing, and cloud-native. Whether you're launching a
                new platform or optimizing an existing one, we ensure seamless
                scalability, multi-tenancy, and integration to help businesses
                grow efficiently.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  fontSize: {
                    xs: "1.6rem",
                    laptop: "1.8rem",
                    md: "1.5rem",
                    xl: "2.5rem",
                  },
                }}
                variant="h3"
              >
                Data Analytics & Business Intelligence
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  paddingLeft: {
                    lg: 15,
                    xl: 35,
                  },
                  textAlign: "right",
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We provide actionable insights through data processing,
                visualization, and strategic analysis, helping businesses
                identify trends, optimize operations, and drive smarter
                decision-making. Our expertise ensures that organizations can
                leverage their data effectively, improving efficiency and
                gaining a competitive edge.
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_2.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "300px",
                minWidth: "250px",
                height: { xs: "150px", md: "200px", lg: "250px" },
                backgroundImage: "url('/images/home/service_3.png')",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: {
                    xs: "1.6rem",
                    laptop: "1.8rem",
                    md: "1.5rem",
                    xl: "2.5rem",
                  },
                }}
                variant="h3"
              >
                Web & Mobile App Development
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  paddingRight: {
                    lg: 15,
                    xl: 35,
                  },
                  fontSize: {
                    xs: "0.8rem",
                    laptop: "0.9rem",
                    lg: "1rem",
                    xl: "1.225rem",
                  },
                }}
              >
                We build scalable and user-centric web and mobile applications
                that enhance engagement, streamline operations, and drive
                business growth. Our solutions are designed for performance,
                flexibility, and seamless user experiences, ensuring your
                business stays ahead in the digital landscape.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

const Services = () => {
  const theme = useTheme();

  const ismdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return ismdScreen ? <WebView /> : <MobileView />;
};

export default Services;
